import styled from 'styled-components';
import { Link } from 'common/design-system/components-v2';

export const SeeDocumentationWrapper = styled(Link)`
    display: flex;
    gap: 4px;
    align-items: center;
`;
